import './LineSkin.css';
import pistol from '../../../../images/pistol.png';
import lineSkinBackground from '../../../../images/lineskinimg.png';
import { User } from '../../../../components/Header/elements/User/User';

export const LineSkin = () => {
    return (
        <div className="line-skin">
            <User />
            <div className="line-skin__container-skin">
                <img src={pistol} alt="" className="line-skin__img" />
                <img src={pistol} alt="" className="line-skin__img" />
                <img src={pistol} alt="" className="line-skin__img" />
            </div>

            <span className="line-skin__money">256.85 р.</span>
            <span className="line-skin__ticket">Билеты #1202-1251</span>

            <img src={lineSkinBackground} alt="" className="line-skin__background" />
        </div>
    );
};
